import React from "react";
import { useNavigate } from "react-router-dom";
import "./ConsultasjonTeaser.css";

function ConsultasjonTeaser({ posts = [] }) {
  const navigate = useNavigate();
  const count = posts.length;

  return (
    <section className="ct-section">
      <div className="ct-bg-overlay" />

      <div className="ct-container">

        <div className="ct-eyebrow">
          {count > 0 ? (
            <><span className="ct-dot" />{count} koranstime{count !== 1 ? "r" : ""} åpen nå</>
          ) : (
            <><span className="ct-dot ct-dot-dim" />Nye koranstimer kommer snart</>
          )}
        </div>

        <h2 className="ct-heading">
          Ta neste steg i<br />
          <span className="ct-accent">din koranreise</span>
        </h2>

        <p className="ct-body">
          Bli med på en av våre koranstimer og styrk
          din tilawa og tajweed — uansett hvor du er i din læring.
        </p>

        <div className="ct-pills">
          <span className="ct-pill">Alle nivåer</span>
          <span className="ct-pill">Tajweed & tilawa</span>
          <span className="ct-pill">Gratis å delta</span>
        </div>

        <button className="ct-cta" onClick={() => navigate("/konsultasjoner")}>
          Se alle timer
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </button>

        <p className="ct-hint">Se datoer og meld deg på direkte</p>

      </div>
    </section>
  );
}

export default ConsultasjonTeaser;
